import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PdfLinkActions from "src/components/PdfLinkActions";
import { strfdate } from "../../../utils/dates";

export default function InboundChargesHeader({ shipment }) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      mt={2}
      flexDirection={{ xs: "column", sm: "row" }}
      gap={1}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Typography fontWeight={500}>{shipment.shipmentId}</Typography>
        <PdfLinkActions
          resourceType="shipment_pdfs"
          resourceId={shipment?.id}
          sx={{
            textTransform: "none",
            fontSize: 12,
            py: 0.2,
            px: 1,
            minWidth: "auto",
            height: 25,
            borderRadius: 10,
          }}
        />
      </Box>
      <Typography fontWeight={500}>Received On: {strfdate(shipment.receivedAt)}</Typography>
    </Box>
  );
}

